module.exports = __webpack_public_path__ + "assets/img/30.5c646fc6.png";